import React, {useEffect} from "react";
import "./WhyUs.css";
import AOS from "aos";
import "aos/dist/aos.css";

const WhyUsSection = () => {

    useEffect(() => {
        AOS.init({
          duration: 1000,
          once: true,
        });
      }, []);
    
  const reasons = [
    {
      icon: "🌟",
      title: "Unmatched Quality",
      description: "High-performance tools engineered for precision, durability, and consistency.",
    },
    {
      icon: "💡",
      title: "Innovation-Driven",
      description: "Cutting-edge technologies that address evolving industrial needs.",
    },
    {
      icon: "💰",
      title: "Cost-Effective Solutions",
      description: "Competitive pricing without compromising on quality.",
    },
    {
      icon: "🤝",
      title: "Customer Focus",
      description: "Tailored solutions and exceptional support for every client.",
    },
    {
      icon: "🌍",
      title: "Sustainability",
      description: "Environmentally conscious manufacturing practices.",
    },
  ];

  return (
    <div className="why-us-secondary-section" data-aos="zoom-in">
      <h2 className="section-title">Why Choose Us?</h2>
      <div className="reason-box">
        <ul className="reason-list">
          {reasons.map((reason, index) => (
            <li key={index} className="reason-item">
              <div className="icon">{reason.icon}</div>
              <h3 className="title">{reason.title}</h3>
              <p className="description">{reason.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WhyUsSection;
